import { render } from "./SelectGroup.vue?vue&type=template&id=f8c74b06&scoped=true"
import script from "./SelectGroup.vue?vue&type=script&lang=js"
export * from "./SelectGroup.vue?vue&type=script&lang=js"

import "./SelectGroup.vue?vue&type=style&index=0&id=f8c74b06&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8c74b06"]])

export default __exports__